import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { matchPath } from 'react-router';
import { withRouter } from 'react-router-dom';
import CircularProgressbar from 'react-circular-progressbar';
import "./css/materialize.css";
import "./css/style.css";
import "./css/circular-progress.css";
import axios from 'axios';
import QRQinectAPI, { API_URL } from '../QRQinectAPI';
import { Player, BigPlayButton } from 'video-react';

class VideoSelection extends Component {
    constructor(props) {
        super(props);
        this.renderBody = this.renderBody.bind(this);
        this.renderHeader = this.renderHeader.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);

        this.state = props.state || props.location.state || {};
        this.state.selectedFileWidth = null;
        this.state.selectedFileHeight = null;
        this.state.name = '';
        this.state.redirectURLError = '';

        this.state.maxVideoLengthMinutes = 10;

        // if the screen is smaller than an iphone 5 (460 inner height, round to 500 for good measure)
        // then we'll have special styling (remove bottom margin) to allow the buttons to show
        this.state.smallscreen = window.innerHeight < 500 ? true : false;
        let maxVideoHeight = window.innerHeight / 2.3;
        this.state.videoHeight = maxVideoHeight;
        this.state.maxVideoHeight = maxVideoHeight;
        this.state.videoWidth = '100%';
        this.state.maxVideoWidth = '100%';
        this.state.videoLoaded = false;
        this.state.playerExists = false;
        this.state.haveScreenShot = false;
        this.state.showSelectURL = false;

        this.screenShot = "";
        this.screenShotHeight = "";
        this.screenShotWidth = "";
        this.video = null;
        this.calledVideoLoad = false;

        this.nickname = props.state.QRCode.Name;
        this.redirectURL = props.state.QRCode.Redirect;
    }
    componentDidMount() {
        let scannedQRCode = matchPath(window.location.pathname, {
            path: '/scan/:id/video/:token',
            exact: false
        });
        let buyerToken = scannedQRCode ? scannedQRCode.params.token: null;
        let qrGUID = scannedQRCode ? scannedQRCode.params.id: null;
        this.setState({token: buyerToken, qrGUID: qrGUID});
        let buyerEmail = null;
        let buyerError = false;
        // TODO: call api, pass in the token (instead of email) and verify the buyer.
        axios.get(API_URL + 'api/v1/allowAddVideoToQRCode', {
            params: {
                Token: buyerToken,
                qrGUID: qrGUID
            }
        })
            .then((response) => {
                buyerEmail = response.data;
            })
            .catch((error) => {
                console.log("error");
                console.log(error);
                buyerError = true;
            })
            .finally( () => {
                if (this.state.Buyer.Email !== buyerEmail) {
                    // we have a problem here...
                    buyerError = true;
                }
                this.setState({ uploading: false, uploadPercent: 0, buyerError: buyerError });
            });
        // console.log(buyerError);
        // // we need to check that this QRCode has a valid buyer, and that the person adding a video is that buyer.
        // if (this.state.Buyer.Email !== buyerEmail) {
        //     // we have a problem here...
        //     buyerError = true;
        // }
        // this.setState({ uploading: false, uploadPercent: 0, buyerError: buyerError });
    }
    componentDidUpdate() {
        if (this.refs.player) {
            this.refs.player.subscribeToStateChange(this.handlePlayerStateChange.bind(this));
            // get the width of the video container so we know what our actual max width is.
            // max height will be in this.state.
            let elWidth = (ReactDOM.findDOMNode(this.refs.videoContainer).getBoundingClientRect().width);
            if (!this.state.playerExists) {
                this.setState({ playerExists: true, maxVideoWidth: elWidth });
            }
        } else {
            if (this.state.playerExists) {
                this.setState({ playerExists: false, videoLoaded: false, haveScreenShot: false });
            }
        }
    }
    handlePlayerStateChange(state, prevState) {
        // copy player state to this component's state
        if (!this.state.videoLoaded && state.videoHeight) {
            this.video = this.refs.player.video.video;
            // console.log(state);
            let newWidth;
            let newHeight;
            // determine the appropriate width and height for the video
            if (state.videoHeight > state.videoWidth) {
                // vertical video, set videoHeight to maxHeight, set videoWidth to maxHeight * aspectRatio
                newHeight = this.state.maxVideoHeight;
                newWidth = ((state.videoWidth / state.videoHeight) * newHeight);

            } else {
                // horizontal video, maxWidth, adjust height
                newWidth = this.state.maxVideoWidth;
                newHeight = ((state.videoHeight / state.videoWidth) * newWidth);
            }
            this.setState({ videoHeight: newHeight, videoWidth: newWidth, videoLoaded: true });
        }
    }
    takeScreenshotAndUpload = () => {
        this.video = this.video || this.refs.player.video.video;//document.querySelector("video");
        if (this.video.readyState !== 4 && !this.calledVideoLoad) { // this.calledVideoload should prevent this from happening multiple times
            // we need to get the video into a ready state so we can get a screenshot
            // this is causing issues with the 'nickname' field.
            this.video.addEventListener('loadeddata', this.uploadHandler);
            this.video.addEventListener('error', this.videoErrorHandler);
            this.video.load();
            this.calledVideoLoad = true;
            // this.video.play();
            // this.video.pause();
            return;
        } else {
            let maxVideoLengthSeconds = (this.state.maxVideoLengthMinutes * 60) + 1
            if (this.video.duration >= maxVideoLengthSeconds) {
                let minutes = Math.floor(this.video.duration / 60);
                let seconds = Math.floor(this.video.duration - minutes * 60);
                this.setState({ error: "The selected video is " + minutes + "m " + seconds + "s long. Please select a video that is " + this.state.maxVideoLengthMinutes + " minutes or less in length." });
                return;
            }

            // let context = this.refs.screenShotCanvas.getContext('2d');

            // this.refs.screenShotCanvas.width = this.video.videoWidth;
            // this.refs.screenShotCanvas.height = this.video.videoHeight;
            // context.drawImage(this.video, 0, 0, this.video.videoWidth, this.video.videoHeight);
            // // now add a play icon to the image
            // context.drawImage(this.refs.playIconImage, this.refs.screenShotCanvas.width / 2 - this.refs.playIconImage.width / 2,
            //     this.refs.screenShotCanvas.height / 2 - this.refs.playIconImage.height / 2);
            // this.screenShot = this.refs.screenShotCanvas.toDataURL("image/png");
            // this.screenShotHeight = this.video.videoHeight;
            // this.screenShotWidth = this.video.videoWidth;
            this.uploadVideo();
        }
    }
    fileChangedHandler = (event) => {
        this.setState({error: null, selectedFile: event.target.files[0] });
    }
    chooseURL = () => {
        this.setState({showSelectURL: true});
    }
    cancelHandler = () => {
        this.screenShot = "";
        this.calledVideoLoad = false;
        this.setState({showSelectURL: false, selectedFile: null, selectedFileWidth: null, selectedFileHeight: null, haveScreenShot: false, error: null, nameError: null });
    }
    videoErrorHandler = () => {
        this.screenShot = "";
        this.calledVideoLoad = false;
        this.setState({ selectedFile: null, selectedFileWidth: null, selectedFileHeight: null, haveScreenShot: false, error: "There was an error loading your video. Please try another file or video format.", nameError: null });
    }
    //capture a screenshot, upload the video, name, and screenshot to the server
    uploadHandler = () => {
        if (!this.refs.nameField.value) {
            this.setState({ nameError: "Please enter a valid nickname" });
            return;
        }
        if (!this.state.selectedFile) {
            return;
        }
        this.takeScreenshotAndUpload();
        // this.setState({ uploading: true });
        // const formData = new FormData();
        // formData.append('file', this.state.selectedFile, this.state.selectedFile.name);
        // formData.append('QRCode', this.state.QRCode);
        // formData.append('Buyer', this.state.Buyer.ID);
        // formData.append('ContentType', this.state.selectedFile.type);
        // formData.append('Size', this.state.selectedFile.size);
        // formData.append('Extension', this.state.selectedFile.type.substr(this.state.selectedFile.type.lastIndexOf('/') + 1));
        // formData.append('Name', this.refs.nameField.value);
        // formData.append('ScreenShotHeight', this.screenShotHeight);
        // formData.append('ScreenShotWidth', this.screenShotWidth);
        // formData.append('ScreenShot', this.screenShot);

        // axios.post(API_URL + 'api/v1/addVideo', formData, {
        //     headers: {
        //         'Content-Type': 'application/x-www-form-urlencoded'
        //     },
        //     onUploadProgress: progressEvent => {
        //         this.setState({ uploadPercent: Math.floor((progressEvent.loaded / progressEvent.total) * 100) });
        //     }
        // })
        //     .then((response) => {
        //         this.props.history.push('congratulations');
        //     })
        //     .catch((error) => {
        //         console.log(error);
        //         this.setState({ error: error.response });
        //     })
    }
    addRedirect = () => {
        let isError = false;
        if (!this.refs.redirectURLField.value) {
            this.setState({ redirectURLError: "Please enter a valid URL" });
            isError = true;
        }
        if (!this.refs.nameField.value) {
            this.setState({ nameError: "Please enter a valid nickname" });
            isError = true;
        }
        if (isError) {
            return;
        }
        QRQinectAPI.setQRCodeRedirect(this.state.qrGUID, this.state.Buyer.ID, this.nickname, this.redirectURL)
        .then((response) => {
            this.props.history.push('/scan/' + this.state.qrGUID + '/congratulations/' + this.state.token );
        })
        .catch((error) => {
            console.log(error);
            this.setState({uploadPercent: 0, uploading: false, error: "An error occured updating your code. This may be due to a temporary network error, or a poor internet connection. If the problem persists, please contact us." });
        })
    }
    uploadVideo = () => {
        this.setState({error: false, uploading: true });
        const formData = new FormData();
        formData.append('file', this.state.selectedFile, this.state.selectedFile.name);
        formData.append('QRCode', this.state.qrGUID);
        formData.append('Buyer', this.state.Buyer.ID);
        // formData.append('ContentType', this.state.selectedFile.type);
        // formData.append('Size', this.state.selectedFile.size);
        // formData.append('Extension', this.state.selectedFile.type.substr(this.state.selectedFile.type.lastIndexOf('/') + 1));
        formData.append('Name', this.nickname);
        // formData.append('ScreenShotHeight', this.screenShotHeight);
        // formData.append('ScreenShotWidth', this.screenShotWidth);
        // formData.append('ScreenShot', this.screenShot);

        axios.post(API_URL + 'api/v1/addVideo', formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            onUploadProgress: progressEvent => {
                // TODO: after 50%, subtract 1 from the percentage so it holds at 99 until completed.
                // The purpose of this is to show the client that the process hasn't completed even if it shows 100%
                let curPercent = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
                if (curPercent > 50) {
                    curPercent -= 1;
                }
                this.setState({ uploadPercent: curPercent });
            }
        })
            .then((response) => {
                this.props.history.push('/scan/' + this.state.qrGUID + '/congratulations/' + this.state.token );
            })
            .catch((error) => {
                console.log(error);
                this.setState({uploadPercent: 0, uploading: false, error: "An error occured uploading your video. This may be due to a temporary network error, or a poor internet connection. If the problem persists, please contact us." });
            })
    }
    // setting the state on change was causing the entire page to re-render (including the video)
    handleNameChange(event) {
        this.nickname = event.target.value;
        if (this.state.showSelectURL) {
            this.setState({nameError: ''});
        }
    }
    handleRedirectURLChange(event) {
        this.redirectURL = event.target.value;
        this.setState({redirectURLError: ''});
    }
    renderRedirectURLError() {
        if (this.state.redirectURLError) {
            return (
                <div style={{ color: 'red', textAlign: 'center' }}>
                    {this.state.redirectURLError}
                </div>
            );
        }
    }
    renderNameError() {
        if (this.state.nameError) {
            return (
                <div style={{ color: 'red', textAlign: 'center' }}>
                    {this.state.nameError}
                </div>
            );
        }
    }
    renderError() {
        if (this.state.error) {
            return (
                <div style={{ color: 'red', textAlign: 'center' }}>
                    {this.state.error}
                </div>
            );
        }
    }
    renderHeader() {
        if (this.state.uploading) {
            return (
                <div>
                    <p style={{ textAlign: "center" }} >Uploading...</p>
                    <div style={{ margin: "0 auto", width: "50%" }}>
                        <CircularProgressbar
                            percentage={this.state.uploadPercent}
                            text={`${this.state.uploadPercent}%`}
                            background
                            backgroundPadding={6}
                            className="circularProgress"
                            styles={{
                                background: {
                                    fill: '#fff'
                                },
                                trail: { stroke: 'transparent' }
                            }}
                        >
                        </CircularProgressbar>
                    </div>
                    <p style={{ textAlign: 'center' }}>This may take a few minutes, please do not refresh the page.<br /> The upload has not completed until the "Success" message has appeared.</p>
                </div>
            );
        } else if (this.state.selectedFile) {
            return (
                <React.Fragment>
                    <div ref="videoContainer" style={{ minWidth: '270px', width: this.state.videoWidth, maxWidth: '100%', height: this.state.videoHeight, maxHeight: this.state.maxVideoHeight, margin: '0 auto' }}>
                        <Player
                            ref="player"
                            fluid={false}
                            height="100%"
                            width="100%"
                            playsInline
                            src={URL.createObjectURL(this.state.selectedFile)}
                            autoplay={true}
                        >
                            <BigPlayButton position="center" />
                        </Player>
                    </div>
                    <div className="input-field">
                        <input ref="nameField" id="name" type="text" className="validate" defaultValue={this.nickname} onChange={event => this.handleNameChange(event)} />
                        <label htmlFor="name">Nickname</label>
                        {this.renderNameError()}
                        <div style={{ fontWeight: 'bold' }}>i.e., receiver's name, occasion, etc.</div>
                        <div>For your personal reference only. This will not be visible to the receiver.</div>
                    </div>
                </React.Fragment>
            );
        } else if (this.state.showSelectURL) {
            return (
                <React.Fragment>
                    <div className="input-field">
                        <input ref="redirectURLField" id="name" type="text" className="validate" defaultValue={this.redirectURL} onChange={event => this.handleRedirectURLChange(event)} />
                        <label htmlFor="name">Paste URL below to link directly to YouTube or another website.</label>
                        {this.renderRedirectURLError()}
                    </div>
                    <div className="input-field">
                        <input ref="nameField" id="name" type="text" className="validate" defaultValue={this.nickname} onChange={event => this.handleNameChange(event)} />
                        <label htmlFor="name">Give this code a nickname</label>
                        {this.renderNameError()}
                        <div style={{ fontWeight: 'bold' }}>i.e., receiver's name, occasion, etc.</div>
                        <div>For your personal reference only. This will not be visible to the receiver.</div>
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <div style={{ textAlign: 'center' }}>
                    {this.renderHeaderText()}

                    {/* <input className='' type="file" accept="video/*" onChange={this.fileChangedHandler} style={{border: '1px solid', width: '100%', height: '100%', position: 'relative', opacity: '10', zIndex: '2', marginTop: '0px' }} /> */}

                    {/* <div style={{ position: 'relative' }}>
                        <input className='' type="file" accept="video/*" onChange={this.fileChangedHandler} style={{border: '1px red', width: '100%', position: 'relative', opacity: '10', zIndex: '2', marginTop: '0px' }} />
                        <div className='' style={{ position: 'absolute', top: '0px', left: '0px', zIndex: '1', marginTop: '0px' }}>
                            <img src={require("./img/choose_video@2x.png")} alt='' style={{ maxHeight: "50%", maxWidth: "50%", width: 'auto', height: 'auto', margin: '0 auto', marginTop: '10px' }} />
                        </div>
                    </div> */}


                    <img src={require("./img/choose_video@2x.png")} alt='' style={{ maxHeight: "50%", maxWidth: "50%", width: 'auto', height: 'auto', margin: '0 auto', marginTop: '10px' }} />
                </div>
            );
        }
    }
    renderHeaderText() {
        if (this.state.buyerError) {
            return (
                <p>I'm sorry, but it appears that you are not the owner of this Say More Code. If you feel this is an error, please try again.</p>
            );
        } else if (this.props.demoQR) {
            return (
                <React.Fragment>
                    <p>Welcome to the Say More™ Experience!</p>
                    <p>Any video added to this demontration code will be automatically removed shortly after upload to allow someone else to try the experience for themselves.</p>
                </React.Fragment>
            );
        } else {
            return (
                <p>You're now ready to add a message to your code!</p>
            );
        }
    }
    renderBody() {
        if (this.state.buyerError) {
            return null;
        }
        else if (this.state.uploading) {
            return null;
        } else if (this.state.showSelectURL) {
            return (
                <div>
                    <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block', width: '45%', marginRight: '10%', backgroundColor: '#666' }}>BACK</a>
                    <a className="button" onClick={this.addRedirect} style={{ display: 'inline-block', width: '45%' }}>CREATE</a>
                </div>
            );
        } else {
            if (this.state.selectedFile) {
                // we've chosen a file, display cancel and upload buttons
                return (
                    <div>
                        {/* <video src={URL.createObjectURL(this.state.selectedFile)} style={{width: '100%'}} /> */}
                        <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block', width: '45%', marginRight: '10%', backgroundColor: '#666' }}>BACK</a>
                        <a className="button" onClick={this.uploadHandler} style={{ display: 'inline-block', width: '45%' }}>UPLOAD</a>
                    </div>
                );
            } else {
                return (
                    <React.Fragment>
                        <div style={{ textAlign: 'center' }}>
                            Video must be {this.state.maxVideoLengthMinutes} minutes or less
                        </div>
                        <div style={{ /*position: 'relative'*/ }}>
                            <input className='button' type="file" accept="video/*" onChange={this.fileChangedHandler} style={{ width: '100%', height: '100%', top: '0px', left: '0px', position: 'fixed', opacity: '0', zIndex: '2', marginTop: '0px' }} />
                            <div className='button' style={{ /*position: 'absolute', top: '0px', left: '0px', zIndex: '1',*/ marginTop: '0px' }}>
                                CHOOSE OR RECORD VIDEO
                            </div>
                            {this.renderURLOption()}
                        </div>
                    </React.Fragment>
                );
            }
        }
    }
    renderURLOption = () => {
        if (this.props.demoQR) {
            return null;
        }
        return (
            <React.Fragment>
                <div style={{textAlign: 'center', paddingBottom: '24px'}}>- OR -</div>
                <div className='button' onClick={this.chooseURL} style={{ /*position: 'absolute', top: '0px', left: '0px',*/ zIndex: '3', marginTop: '0px' }}>
                    LINK TO ANY WEBSITE URL
                </div>
            </React.Fragment>
        );
    }
    getHeadStyle() {
        if (this.state.smallscreen) {
            return {marginBottom: '0px'};
        } else {
            return null;
        }
    }
    render() {
        return (
            <div>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div className="head" style={this.getHeadStyle()}>
                                <div className="logoImage"></div>
                                {this.renderHeader()}
                            </div>
                            {this.renderError()}
                            {this.renderBody()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(VideoSelection);



// WEBPACK FOOTER //
// ./src/components/VideoSelection.js